import React, { useState, useEffect } from "react";
import useIdle from "react-use/lib/useIdle";
import { SessionTimeoutDialog } from "../SessionTimeoutDialog";

type SessionTimeoutWarningProps = {
  /** Specify the number of milliseconds of idle time to wait before showing the session timeout warning */
  warnAfter: number;

  /** Specify the number of milliseconds to show timeout warning before redirecting to /logout. */
  warningDuration: number;
};

export function SessionTimeoutWarning({
  warnAfter,
  warningDuration,
}: SessionTimeoutWarningProps) {
  const [showWarning, setShowWarning] = useState(false);

  const userHasBeenIdleForWarningLimit = useIdle(warnAfter);
  useEffect(() => {
    if (userHasBeenIdleForWarningLimit) setShowWarning(true);
  }, [userHasBeenIdleForWarningLimit]);

  return showWarning ? (
    <SessionTimeoutDialog
      initialTime={warningDuration}
      onExtendSession={() => setShowWarning(false)}
    />
  ) : null;
}
